import { FlightConfig } from '../../store/schema/NinjaFlightsResponse';
import { getStore } from '../../store/store';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import onFeatureFlagsPaneOpened from '../../actions/onFeatureFlagsPaneOpened';
import onFlightConfigSelected from '../../actions/onFlightConfigSelected';

const styles = require('./FeatureFlagsHeader.scss');

@observer
export default class FeatureFlagsHeader extends React.Component<{}, {}> {
    componentDidMount() {
        onFeatureFlagsPaneOpened();
    }

    render() {
        return (
            <div className={styles.container}>
                <Dropdown
                    onChange={this.onFlightConfigChange}
                    options={this.getFlightConfigDropdownOptions()}
                    selectedKey={getStore().selectedFlightConfig}
                    styles={{
                        root: {
                            width: '100%',
                        },
                    }}
                />
            </div>
        );
    }

    /**
     * Returns array of dropdown options for flight config dropdown.
     */
    private getFlightConfigDropdownOptions = (): IDropdownOption[] => {
        const dropdownItems: IDropdownOption[] = [];

        // Default flight config
        dropdownItems.push({
            key: 'DEFAULT',
            text: 'Default flags',
        });

        // Dogfood flight config
        dropdownItems.push({
            key: 'DOGFOOD',
            text: 'Dogfood feature flags',
        });

        // Microsoft flight config
        dropdownItems.push({
            key: 'MICROSOFT',
            text: 'Microsoft feature flags',
        });

        // WW flight config
        dropdownItems.push({
            key: 'WW',
            text: 'WW feature flags',
        });

        return dropdownItems;
    };

    /**
     * Handler for when user selects a flight config option from the dropdown.
     */
    private onFlightConfigChange = (event: any, option: IDropdownOption) => {
        const { selectedFlightConfig: activeFlightConfig } = getStore();
        const { key: selectedFlightConfig } = option;

        if (selectedFlightConfig === activeFlightConfig) {
            return;
        }

        onFlightConfigSelected(selectedFlightConfig as FlightConfig);
    };
}
